import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
// Register locale data
registerLocaleData(localeFr, 'fr-FR');
const ɵ0 = { animationDuration: '0ms' }, ɵ1 = { appearance: 'legacy' }, ɵ2 = { appearance: 'legacy' }, ɵ3 = {
    minScrollbarLength: 25
};
export class AppModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3 };
